import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectSizeById } from '@ff-scene-plugins/photo-prints-redux/selectors/sizeSelectors';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import styles from './SelectedAccessoryForOptionsGroup.module.scss';

export const SelectedAccessoryForOptionsGroup = ({ sizeId }: { sizeId: string }) => {
    const { t } = useTranslation();

    const accessory = useSelector((state: PhotoPrintsPdpState) => selectSizeById(state, sizeId));

    if (!accessory) {
        return <span></span>;
    }

    return (
        <span className={styles.variants}>
            {t(accessory.name)}
        </span>
    );
};